export const ACTIVATION_TYPES = Object.freeze({
    ONSITE: "onsite",
    CLOUD: "cloud",
});

export const SOURCE_TYPES = Object.freeze({
    RESELLER: "reseller",
    WEB: "web",
});

export const MAINTENANCE_TYPES = Object.freeze({
    0: "1° anno incluso",
    1: "+1 anno (totale 2 anni)",
    3: "+3 anni (totale 4 anni)",
    999: "lifetime",
});
